module.exports = __webpack_public_path__ + "static/koala-b7720f8141210d5588179e96c3d8cecc.png";